<template>
  <div class="role-setting">
    <!-- <div>
      企微控件S
      <qwContacts
        type="userName"
        openid=""
        :datas="[]"
      />
      企微控件E
    </div> -->
    <SpFinder
      id="1"
      ref="finder"
      class="channelCode"
      :url="{
        setting: requestUrl + '/salesperson/salesperson',
        data: requestUrl + '/salesperson/salesperson'
      }"
      :searched="[
        { key: 'employee_number', name: '员工工号', slot: 'employee_number' },
        { key: 'salesperson_name', name: '员工姓名', slot: 'salesperson_name' },
        { key: 'mobile', name: '员工手机', slot: 'mobile' },
        { key: 'salesperson_job', name: '职务', slot: 'salesperson_job' },
        { key: 'role_id', name: '角色', slot: 'role_id' }
      ]"
      title="数据"
      :columns="columns"
      :actions="actions"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      @select-change="handleSelectionChange"
      @reset="onFinderReset"
    >
      <template v-slot:tableTop>
        <div>
          <el-tabs>
            <el-tab-pane label="全部" />
            <el-tab-pane label="员工" />
            <el-tab-pane label="编外" />
            <el-tab-pane label="已启用" />
            <el-tab-pane label="已禁用" />
            <el-tab-pane label="已冻结" />
          </el-tabs>
        </div>
      </template>

      <template v-slot:employee_number>
        <el-input
          v-model="params.employee_number"
          placeholder="请输入工号"
          size="small"
        />
      </template>
      <template v-slot:salesperson_name>
        <el-input
          v-model="params.salesperson_name"
          placeholder="请输入姓名"
          size="small"
        />
      </template>
      <template v-slot:mobile>
        <el-input
          v-model="params.mobile"
          placeholder="请输入手机号"
          size="small"
        />
      </template>
      <template v-slot:salesperson_job>
        <el-input
          v-model="params.salesperson_job"
          placeholder="请输入职务"
          size="small"
        />
      </template>
      <template v-slot:role_id>
        <el-select
          v-model="params.role_id"
          class="select"
          placeholder="请选择"
          size="small"
        >
          <el-option
            label="全部"
            value=""
          />
          <el-option
            v-for="item in roleList"
            :key="item.role_id"
            :label="item.role_name"
            :value="item.role_id"
          />
        </el-select>
      </template>
    </SpFinder>

    <!-- 添加、编辑标识-开始 -->
    <el-dialog
      :title="editRoleTitle"
      :visible.sync="editRoleVisible"
      :before-close="handleCancel"
    >
      <template>
        <el-form
          ref="form"
          :model="form"
          class="demo-ruleForm"
          label-width="90px"
        >
          <el-form-item label="角色名称">
            <el-col :span="14">
              <el-input
                v-model="form.role_name"
                :maxlength="20"
                placeholder="订单管理员、商品管理员、等等"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="角色权限">
            <el-tree
              ref="tree"
              :data="$store.getters.menus"
              :default-checked-keys="defaultCheckedKeys"
              node-key="id"
              :props="defaultProps"
              show-checkbox
            />
          </el-form-item>
        </el-form>
      </template>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="handleCancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submitRoleAction"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 添加、编辑基础物料-结束 -->

    <!-- 冻结/解冻模态框 -->
    <el-dialog
      title="变更冻结状态"
      :visible.sync="freezeVisible"
      width="600px"
      :before-close="dialogFreezeClose"
    >
      <div>
        <el-radio-group v-model="freezeStatus">
          <el-radio :label="1">
            冻结
          </el-radio>
          <el-radio :label="2">
            解冻
          </el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button @click="freezeVisible = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          :loading="freezeloading"
          @click="submitFreeze"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 变更绑定角色模态框 -->
    <el-dialog
      title="变更绑定角色"
      :visible.sync="bindRoleVisible"
      width="600px"
      :before-close="dialogBindRoleClose"
    >
      <div>
        <el-radio-group v-model="bindRoleId">
          <el-radio
            v-for="item in roleList"
            :key="item.role_id"
            :label="item.role_id"
          >
            {{ item.role_name }}
          </el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button @click="bindRoleVisible = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          :loading="bindRoleLoading"
          @click="submitBindRole"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <div>测试测试测试</div>
    <ExportGuideCode
      :code-visible="guideCodeVisible"
      @closeDialog="dialogGuideCodeClose"
    />

    <!-- 更新数据 -->
    <SpRefreshStore
      :refresh-visible="refreshStoreVisible"
      @closeRefreshStoreDialog="closeRefreshStoreDialog"
    />

    <!-- 门店列表 -->
    <StoreList
      :store-visible="storeListVisible"
      :action_type="action_type"
      :set-store-row="setStoreRow"
      @closeStoreDialog="closeStoreListDialog"
      @saveStoreAction="saveStoreAction"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ExportGuideCode from '../components/exportGuideCode'
import StoreList from '../components/storeList'
// import qwContacts from '@/components/qwContacts'
export default {
  components: {
    ExportGuideCode,
    StoreList
    // qwContacts
  },
  data () {
    const columns = [
      {
        name: '员工工号', // 表头
        key: 'employee_number', // 匹配data key
        width: 100,
        render: (h, { row }) => {
          return <div>{row.employee_number || '--'}</div>
        }
      },
      {
        name: '员工姓名', // 表头
        key: 'salesperson_name', // 匹配data key
        width: 100
      },
      {
        name: '所属门店',
        key: 'store_name',
        width: 150,
        render: (h, { row }) => {
          let name =
            row.store_num > 0 ? (
              row.store_name
            ) : (
              <div style='color:skyblue;cursor:pointer;' onClick={this.selectStoreList(row, 'add')}>
                {'绑定门店'}
              </div>
            )
          return <div>{name}</div>
        }
      },
      {
        name: '类型',
        key: 'employee_status',
        width: 100,
        render: (h, { row }) => {
          const other = !row.employee_status == 1 && !row.employee_status === 2
          return (
            <div>
              {row.employee_status === 1 && <span>员工</span>}
              {row.employee_status === 2 && <span>编外</span>}
              {other && <span>--</span>}
            </div>
          )
        }
      },
      {
        name: '启用',
        key: 'salesperson_status',
        width: 100,
        render: (h, { row }) => {
          const other = !row.salesperson_status == 1 && !row.employee_status === 2
          return (
            <div>
              {row.salesperson_status === 1 && (
                <el-tag type='success' size='mini' effect='dark'>
                  启用
                </el-tag>
              )}
              {row.salesperson_status === 2 && (
                <el-tag type='success' size='mini' effect='dark'>
                  已冻结
                </el-tag>
              )}
              {other && <span>禁用</span>}
            </div>
          )
        }
      },
      {
        name: '员工职务',
        key: 'salesperson_job',
        width: 100,
        render: (h, { row }) => {
          return <div>{row.salesperson_job || '--'}</div>
        }
      },
      {
        name: '手机号',
        key: 'mobile',
        width: 100,
        render: (h, { row }) => {
          return <div>{row.mobile || '--'}</div>
        }
      },
      {
        name: '更新时间',
        key: 'updated_at',
        width: 140,
        render: (h, { row }) => {
          return <div>{row.updated_at || '--'}</div>
        }
      },
      {
        name: '角色权限',
        key: 'role_name',
        width: 100,
        render: (h, { row }) => {
          return <div>{row.role_name || '--'}</div>
        }
      }
    ]
    const actions = [
      {
        name: '更新数据',
        key: 'updateData', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        buttonIcon: 'el-icon-refresh-right',
        action: {
          type: 'link',
          path: (row, _) => {
            this.haddleRefresh()
          }
        }
      },
      {
        name: '批量更改角色',
        key: 'batchUpdateRoles', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        buttonIcon: 'el-icon-edit-outline',
        action: {
          type: 'link',
          path: (row, _) => {
            this.haddleBindRole()
          }
        }
      },
      {
        name: '批量更改冻结状态',
        key: 'batchUpdateStatus', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        buttonIcon: 'el-icon-edit-outline',
        action: {
          type: 'link',
          path: (row, _) => {
            this.handleFreeze()
          }
        }
      },
      {
        name: '导出导购码',
        key: 'exportCode', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        buttonIcon: 'el-icon-download',
        action: {
          type: 'link',
          path: (row, _) => {
            this.haddleGuideCode()
          }
        }
      },
      {
        name: '角色解绑',
        key: 'roleunbind',
        type: 'button',
        action: {
          type: 'link',
          path: (row) => {
            this.haddleUnBindRole(row)
          } // 方法方式跳转
        }
      },
      {
        name: '冻结',
        key: 'freeze',
        type: 'button',
        action: {
          type: 'link',
          path: (row) => {
            this.handleFreeze(row)
          } // 方法方式跳转
        }
      },
      {
        name: '下载导购码',
        key: 'dowload',
        type: 'button',
        action: {
          type: 'link',
          path: (row) => {
            this.downloadCode(row)
          } // 方法方式跳转
        }
      },
      {
        name: '查看门店',
        key: 'viewshop',
        type: 'button',
        action: {
          type: 'link',
          path: (row) => {
            this.selectStoreList(row, 'remove')
          } // 方法方式跳转
        }
      }
    ]

    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isEdit: false,
      editRoleVisible: false,
      editRoleTitle: '',
      form: {
        role_name: '',
        role_id: '',
        permission: []
      },
      bindRoleLoading: false, //绑定角色的加载
      searchInput: '',
      defaultCheckedKeys: [],
      rolesList: [],
      loading: false,
      bindRoleId: 0, //绑定角色弹窗的选中角色id
      total_count: 0,
      multipleSelection: [], //多选列表
      bindRoleVisible: false, //变更绑定角色
      params: {
        page: 1,
        page_size: 20,
        employee_status: 'all', //查询状态 [all 全部] [employee 员工] [external_employee 编外]
        salesperson_status: '', //禁用状态 [disabled 禁用] [opening 启用] [freezing 冻结]
        role_id: '',
        salesperson_job: '',
        employee_number: '', //员工工号
        mobile: ''
      },
      guideCodeVisible: false, //导购码
      roleList: [], //角色列表
      columns,
      actions,
      requestUrl: process.env.VUE_APP_BASE_API,
      refreshStoreVisible: false, //更新数据展示与否
      setRoleSaleIds: '', //更改角色的员工id值，支持单个和多个
      freezeVisible: false, //冻结、解冻展示
      freezeStatus: 0, //冻结状态
      freezeloading: false, //冻结、解冻的加载
      storeListVisible: false, //选择门店展示与否
      action_type: 'add', //门店操作方法，选项：add：绑定、remove：解绑, 默认add
      setStoreRow: {} //编辑中的列表数据
    }
  },
  computed: {
    ...mapGetters([])
  },
  mounted () {
    this.getRoleList()
  },
  methods: {
    // 角色解绑
    haddleUnBindRole (row) {
      this.$confirm('此操作将解绑角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let salesperson_id = row.salesperson_id.toString()
        const data = await this.$api['staffManagement/rolePrivileges'].unBindRole({
          salesperson_id
        })
        if (data) {
          this.$refs.finder.refresh(true)
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      })
    },
    // 门店操作
    selectStoreList (row, type) {
      this.action_type = type
      this.setStoreRow = row
      this.storeListVisible = true
    },
    // 关闭门店列表
    closeStoreListDialog () {
      this.storeListVisible = false
    },
    // 关闭冻结、解冻
    dialogFreezeClose () {
      this.freezeVisible = false
    },
    // 冻结解冻操作
    handleFreeze (row) {
      if (row) {
        this.freezeStatus = row.salesperson_status
        this.setFreezeSaleIds = row.salesperson_id.toString()
      } else {
        if (this.multipleSelection.length <= 0) {
          return this.$message.error('请至少勾选一个需要变更冻结或解冻的员工')
        }
        this.freezeStatus = 0
        let setFreezeSaleIds = []
        this.multipleSelection.forEach((v) => {
          setFreezeSaleIds = setFreezeSaleIds.concat(v.salesperson_id)
        })
        this.setFreezeSaleIds = setFreezeSaleIds.join(',')
      }
      this.freezeVisible = true
    },
    // 多选
    handleSelectionChange ({ selection }) {
      console.log('handleSelectionChange', selection)
      const newSelection = [].concat(selection)
      this.multipleSelection = newSelection
    },
    // 更新导购列表
    haddleRefresh () {
      this.refreshStoreVisible = true
    },
    closeRefreshStoreDialog () {
      this.refreshStoreVisible = false
    },
    async haddleGuideCode () {
      this.guideCodeVisible = true
    },
    dialogGuideCodeClose () {
      this.guideCodeVisible = false
    },
    // 确定冻结、解冻
    async submitFreeze () {
      let salesperson_status = this.freezeStatus
      let params = {
        salespersonId: this.setFreezeSaleIds,
        // 导购状态，2：冻结；1：启用、解冻
        salesperson_status: salesperson_status === 1 ? 2 : salesperson_status === 2 ? 1 : ''
      }
      const data = await this.$api['staffManagement/salesman'].updateFreeze(params).catch(() => {
        this.freezeloading = false
      })
      if (data) {
        this.freezeloading = false
        this.freezeVisible = false
        this.$message({
          message: '变更成功',
          type: 'success'
        })
        this.$refs.finder.refresh(true)
      }
    },
    // 获取绑定角色列表数据
    async getRoleList () {
      const data = await this.$api['staffManagement/rolePrivileges'].getRoleList({
        page: 1,
        page_size: 100
      })
      if (data) {
        this.roleList = data.list
      }
    },
    // 门店操作成功
    saveStoreAction () {
      this.$refs.finder.refresh(true)
    },
    // 更改角色
    haddleBindRole (row) {
      if (row) {
        this.bindRoleId = +row.role_id
        this.setRoleSaleIds = row.salesperson_id.toString()
      } else {
        if (this.multipleSelection.length <= 0) {
          return this.$message.error('请至少勾选一个需要变更角色的员工')
        }
        this.bindRoleId = 0
        let setRoleSaleIds = []
        this.multipleSelection.forEach((v) => {
          setRoleSaleIds = setRoleSaleIds.concat(v.salesperson_id)
        })
        this.setRoleSaleIds = setRoleSaleIds.join(',')
      }
      this.bindRoleVisible = true
    },
    // 关闭绑定角色
    dialogBindRoleClose () {
      this.bindRoleVisible = false
    },
    // 确定绑定
    async submitBindRole () {
      this.bindRoleLoading = true
      let params = {
        salesperson_id: this.setRoleSaleIds,
        role_id: this.bindRoleId
      }
      const data = await this.$api['staffManagement/rolePrivileges'].bindRole(params).catch(() => {
        this.bindRoleLoading = false
      })
      if (data) {
        this.bindRoleLoading = false
        this.bindRoleVisible = false
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
        this.$refs.finder.refresh(true)
      }
    },

    handleCancel () {
      this.editRoleVisible = false
      this.$refs.tree.setCheckedKeys([])
    },
    //下载导购码
    async downloadCode (item) {
      const self = this
      const data = await self.$api['staffManagement/salesman'].getSalesersonCode(
        item.salesperson_id
      )
      if (data) {
        this.downloadIamge(data.qr_code, item.salesperson_name)
      }
    },
    downloadIamge (imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc + '?time=' + Date.now()
    },
    // 搜索重置
    onFinderReset () {
      this.params = {
        page: 1,
        page_size: 20
      }
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
    },
    addRoleLabels () {
      // 添加物料弹框
      this.editRoleTitle = '角色添加'
      this.editRoleVisible = true
      this.isEdit = false
      this.form.role_name = ''
      this.form.role_id = ''
      this.form.permission = []
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([])
      } else {
        this.defaultCheckedKeys = []
      }
    },
    beforeSearch (params) {
      console.log('beforeSearch:', params)
      if (params.qs) {
        delete params.qs
      }
      if (this.params.search) {
        params['search'] = this.params.search
      }
      if (this.params.employee_number) {
        params['employee_number'] = this.params.employee_number
      }
      if (this.params.salesperson_name) {
        params['salesperson_name'] = this.params.salesperson_name
      }
      if (this.params.mobile) {
        params['mobile'] = this.params.mobile
      }
      if (this.params.salesperson_job) {
        params['salesperson_job'] = this.params.salesperson_job
      }
      if (this.params.role_id) {
        params['role_id'] = this.params.role_id
      }
      return params
    },
    editRoleAction (row) {
      const self = this
      // 编辑物料弹框
      this.editRoleTitle = '角色编辑'
      this.editRoleVisible = true
      this.isEdit = true
      this.form.role_name = row.role_name
      this.form.role_id = row.role_id

      this.$api['setting/roleSetting'].getRolesInfo(self.form.role_id).then((response) => {
        const { permission } = response
        console.log('---permission--', permission)
        if (self.$refs.tree) {
          self.$refs.tree.setCheckedKeys(row.permission)
        } else {
          self.defaultCheckedKeys = row.permission
        }
      })
    },
    submitRoleAction () {
      // 提交物料
      const self = this
      var checkedNodes = this.$refs.tree.getCheckedNodes()
      var checkedKeys = []
      checkedNodes.forEach((item) => {
        if (!item.isChildrenMenu) {
          checkedKeys.push(item.id)
        }
      })

      var version = this.$store.getters.menus[0].version
      this.form.permission = checkedKeys

      if (this.form.role_id) {
        self.$api['setting/roleSetting']
          .updateRolesInfo(this.form.role_id, this.form)
          .then((response) => {
            this.editRoleVisible = false
            this.handleCancel()
          })
      } else {
        self.$api['setting/roleSetting'].createRoles(this.form).then((response) => {
          this.editRoleVisible = false
          this.handleCancel()
        })
      }
    },
    roleSearch () {
      this.params.page = 1
    },
    deleteRoleAction (row) {
      const self = this
      this.$confirm('此操作将删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          self.$api['setting/roleSetting'].deleteRole(row.role_id).then((response) => {
            self.$refs.finder.refresh()
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>
<style scoped lang="scss"></style>
